import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _UserStatusModal_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './user-status.hbs'; */
import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import ItsATrap from "@discourse/itsatrap";
import { TrackedObject } from "@ember-compat/tracked-built-ins";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { TIME_SHORTCUT_TYPES, timeShortcuts } from "discourse/lib/time-shortcut";
import TEMPLATE from "./user-status.hbs";
import { setComponentTemplate } from "@ember/component";
let UserStatusModal = (_class = (_UserStatusModal_brand = /*#__PURE__*/new WeakSet(), class UserStatusModal extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserStatusModal_brand);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "dialog", _descriptor2, this);
    _defineProperty(this, "status", new TrackedObject({
      ...this.args.model.status
    }));
    _defineProperty(this, "timeShortcuts", _assertClassBrand(_UserStatusModal_brand, this, _buildTimeShortcuts).call(this));
    _defineProperty(this, "_itsatrap", new ItsATrap());
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this._itsatrap.destroy();
  }
  get showDeleteButton() {
    return !!this.args.model.status;
  }
  get prefilledDateTime() {
    return this.status?.ends_at;
  }
  get saveDisabled() {
    return !this.status?.emoji || !this.status?.description;
  }
  get customTimeShortcutLabels() {
    return {
      [TIME_SHORTCUT_TYPES.NONE]: "time_shortcut.never"
    };
  }
  get hiddenTimeShortcutOptions() {
    return [TIME_SHORTCUT_TYPES.LAST_CUSTOM];
  }
  onTimeSelected(_, time) {
    this.status.endsAt = time;
  }
  async delete() {
    try {
      await this.args.model.deleteAction();
      this.args.closeModal();
    } catch (e) {
      _assertClassBrand(_UserStatusModal_brand, this, _handleError).call(this, e);
    }
  }
  async saveAndClose() {
    const newStatus = {
      description: this.status.description,
      emoji: this.status.emoji,
      ends_at: this.status.endsAt?.toISOString()
    };
    try {
      await this.args.model.saveAction(newStatus, this.args.model.pauseNotifications);
      this.args.closeModal();
    } catch (e) {
      _assertClassBrand(_UserStatusModal_brand, this, _handleError).call(this, e);
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onTimeSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTimeSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "delete", [action], Object.getOwnPropertyDescriptor(_class.prototype, "delete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveAndClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveAndClose"), _class.prototype)), _class);
function _buildTimeShortcuts() {
  const shortcuts = timeShortcuts(this.currentUser.user_option.timezone);
  return [shortcuts.oneHour(), shortcuts.twoHours(), shortcuts.tomorrow()];
}
function _handleError(e) {
  if (typeof e === "string") {
    this.dialog.alert(e);
  } else {
    popupAjaxError(e);
  }
}
export { UserStatusModal as default };
setComponentTemplate(TEMPLATE, UserStatusModal);